<template>
  <BethsLayout>
    <h1>Help</h1>
  </BethsLayout>
</template>
